/**
 * Wishlist Cookie Constants
 *
 * Shared constants used by both client and server cookie utilities.
 * This file has no server-only dependencies so it can be safely imported anywhere.
 */

import { BRAND } from '@/lib/cms/config';

/**
 * Brand prefix for cookies — follows `NEXT_PUBLIC_BRAND` via `lib/cms/config`.
 */

/**
 * Cookie name prefix for wishlist
 * Full cookie name is: {brand}_wishlist_{countryCode}
 */
export const WISHLIST_COOKIE_PREFIX = `${BRAND}_wishlist_`;

/**
 * Cookie max age: 365 days in seconds
 * Longer than checkout since wishlists are more persistent
 */
export const WISHLIST_COOKIE_MAX_AGE = 365 * 24 * 60 * 60;

/**
 * Minimal item data stored in cookie
 * Only what's needed to fetch full product details from Algolia
 */
export interface WishlistCookieItem {
  /** Product SKU */
  sku: string;
  /** Product type for routing to correct Algolia index */
  type: string;
}
